<template>
  <div>
    <Pos_edit_product_service/>
  </div>
</template>

<script>
import Pos_edit_product_service
  from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_edit_product_service";
export default {
  name: "PosEditProductService",
  components: {
    Pos_edit_product_service
  }
}
</script>

<style scoped>

</style>
